<template>
<div>
    <span v-if="loading">
        <div>
            <img class="d-none d-lg-block" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/single-slider-D.svg" alt="" srcset="">
            <img class="d-none d-md-block d-lg-none" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/single-slider-D.svg" alt="" srcset="">
            <img class="d-block d-md-none" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/single_slider-mobile.svg" alt="" srcset="">
        </div>
    </span>
    <span v-if="!loading">
        <div class="mt-5" v-if="instances && instances.length">
            <span>
                <div id="instance">
                    <div class="splide newFeatureSlider mb-4 instance__splide" aria-label="Slider for instances">
                        <div class="splide__track mask-container">
                            <div class="splide__list">
                                <div class="splide__slide" v-for="(singleInstance, index) in instances" :key="index">
                                    <div class="card border-0 rounded-bottom-10 rounded-top-10 h-100 " v-if="singleInstance && singleInstance.colourHexCode" :style="{
                                        'background': 'linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.00) 28.87%), ' +
                                        'linear-gradient(0deg, rgba(0, 0, 0, 0.25) -0.11%, rgba(0, 0, 0, 0.00) 35.2%), ' +
                                        singleInstance.colourHexCode + ''
                                        }">
                                        <a :href="[singleInstance.url]" class="position-relative pick-poc-card-img" v-if="singleInstance.image">
                                            <img class="rounded-top-10 w-100 instance--image pt-1" :alt="singleInstance?.name" v-if="singleInstance.image" :src="singleInstance.image" />
                                            <h5 class="sands--hide" v-if="singleInstance.name">{{singleInstance.name}}</h5>
                                        </a>
                                        <div class="card-body mt-2 d-flex flex-column py-2 text-center">
                                            <a :href="[singleInstance.url]" class="d-flex flex-column h-100 justify-content-between text-white">
                                                <h5 v-if="singleInstance.name">{{singleInstance.name}} <span v-if="singleInstance.designation">{{singleInstance.designation}}</span></h5>

                                                <h6 v-if="singleInstance.dispalyDate">{{singleInstance.dispalyDate}}</h6>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
        </div>

    </span>
</div>
</template>

<script>
import Splide from "@splidejs/splide";
import queryAndMutaionService from '../../services/queryAndMutaionService.js';
import helperfunctions from "../../services/helperfunctions.js";
import moment from 'moment';
export default {
    name: "brandInstances",
    created() {
        if (this.settingsPerm && this.settingsPerm.brandSlug) {
            this.getInstanceFromConcord(this.settingsPerm.brandSlug);
        }
        if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
            this.showItemBaseOfLangDe = false;
        }
    },
    data() {
        return {
            showItemBaseOfLangDe: true,
            instances: [],
        };
    },
    props: {
        settingsPerm: Object,
    },
    methods: {
        getInstanceFromConcord(slug) {
            queryAndMutaionService.getBrandRelatedInstanceData(slug).then((data) => {
                if (data && data.brandComplexCurrentInstances && data.brandComplexCurrentInstances.Instances && data.brandComplexCurrentInstances.Instances.length > 0) {
                    this.instances = data.brandComplexCurrentInstances.Instances.map(instance => ({
                            ...instance
                        })),
                        this.instances.forEach(instance => {
                            if (!instance.colourHexCode) {
                                instance.colourHexCode = this.showItemBaseOfLangDe ? '#017e8e' : '#2ac2bc';
                            }
                            if (instance.schemaType && ((instance.startDate && instance.endDate) || instance.publishedAt)) {
                                instance.dispalyDate = this.constructDisplayDate(instance.schemaType,instance.startDate, instance.endDate,instance.publishedAt,instance.timezone);
                            }
                            if (instance.schemaType && instance.slug) {
                                instance.url = this.getSlugUrl(instance);
                            }
                        });
                    this.loading = false;
                    this.mount_splide();

                } else {
                    this.loading = false;
                }
            });
        },

        constructDisplayDate(schemaType, startDate, endDate, publishedAt, timezone) {
            if (schemaType && schemaType == "Course") {
                if (moment(startDate, 'DD-MM-YYYY HH:mm:ss').isValid() && moment(endDate, 'DD-MM-YYYY HH:mm:ss').isValid()) {
                    if (moment(startDate, 'DD-MM-YYYY HH:mm:ss').format('YYYY') === moment(endDate, 'DD-MM-YYYY HH:mm:ss').format('YYYY')) {

                        return helperfunctions.getUserLocalizeTime(
                            startDate,
                            timezone,
                            'DD.MMM '
                        ) + ' - ' + helperfunctions.getUserLocalizeTime(
                            endDate,
                            timezone,
                            'DD.MMM YYYY'
                        );
                    } else {
                        return helperfunctions.getUserLocalizeTime(
                            startDate,
                            timezone,
                            'DD. MMM YYYY'
                        ) + ' - ' + helperfunctions.getUserLocalizeTime(
                            endDate,
                            timezone,
                            'DD. MMM YYYY'
                        );
                    }
                }
            } else if (schemaType && schemaType == "Issue") {
                if (moment(publishedAt, 'DD-MM-YYYY HH:mm:ss').isValid()) {
                    return moment(publishedAt, 'DD-MM-YYYY HH:mm:ss', this.language).format('DD. MMM YYYY');
                }
            }
            return '';
        },
        getSlugUrl(instance) {
            if (instance.schemaType === 'Course') {
                return '/conferences/' + instance.slug;
            } else if (instance.schemaType === 'Issue' && instance.designation && instance.name) {
                let magazineSlug = instance.name.replace(' ', '-');
                return '/magazine-ebooks/' + magazineSlug + '/' + instance.designation;
            }

            return '';
        },

        mount_splide: function () {
            let thiz = this;
            let padding = {
                right: "0rem",
                left: "0rem",
            };
            setTimeout(function () {
                if (thiz.pocs && thiz.pocs.length && thiz.pocs.length > 3) {
                    padding = {
                        right: "0rem",
                        left: "0rem",
                    };
                }
                if (!thiz.splide) {
                    thiz.splide = new Splide('.instance__splide', {
                        classes: {
                            arrows: 'splide__arrows arrows',
                            arrow: 'splide__arrow arrow',
                            prev: 'splide__arrow--prev prev',
                            next: 'splide__arrow--next next',
                        },
                        perPage: 3,
                        perMove: 1,
                        gap: '1rem',
                        rewind: false,
                        pagination: false,
                        padding: padding,
                        breakpoints: {
                            1600: {
                                perPage: 3,
                            },
                            1280: {
                                perPage: 2,
                            },
                            991: {
                                perPage: 2,
                            },
                            767: {
                                perPage: 1,
                            },
                            575: {
                                perPage: 1,
                                padding: {
                                    left: '0rem',
                                    right: '5rem'
                                },
                                arrows: false,
                                start: 0,
                            },
                        },
                    });
                    thiz.splide.mount();
                } else {
                    thiz.splide.refresh(); // Refresh the existing Splide instance
                }
            }, 500);
        },
    },

};
</script>

<style>
/* .pick-poc-card-img img{
    min-height: 175px;
    max-height: 175px;
    width: 100%;
} */

.pick-poc-card-img img {
    height: 175px;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .pick-poc-card-img img{
    height: 100%;
}
}

@media screen and (min-width: 1281px) and (max-width: 1680px) {
    .pick-poc-card-img img {
    height: 135px;
  }
}
</style>
